import ProductsList from './ProductsList'


const Carousel = ({ products, loadProducts }) =>
  <ProductsList products={products}/>

  export default Carousel